/*
 * @Author: Json Chen
 * @Date: 2021-07-13 14:13:37
 * @LastEditTime: 2022-06-01 16:00:02
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/index.tsx
 */

import {
  delCourier,
  getCourierList,
} from '@/src/request/settings/logistics/courieraccount';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { InfoCircleFilled } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Button, Modal, SizeFittingTable } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { AddCourierAccount, DelModalContent } from './Components/ModalContents';
import styles from './style.module.less';
import { getCourierShow, transformTypeRes } from './tools';
import { CourierAccountType, SFLocation } from './type';

const permissions = () => {
  const add_edit_courier_account_parcel_locker_delivery_method = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation:
          EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
      }),
    ],
  });
  return {
    add_edit_courier_account_parcel_locker_delivery_method,
  };
};
const CourierAccount = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { add_edit_courier_account_parcel_locker_delivery_method } =
    permissions();
  const history = useHistory();
  const params: any = useParams();
  const [list, setList] = useState([]);
  const [modalContent, setModalContent] = useState<any>();

  const [visiable, setVisiable] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<any>();
  const { uuid: warehouseUuid } = params;

  const { loading: getCourierListLoading, run: _getCourierList } = useRequest(
    getCourierList,
    {
      manual: true,
      onSuccess(result) {
        setList(result);
      },
    },
  );

  const { loading: delCourierLoading, run: _delCourier } = useRequest(
    (uuid) => delCourier(uuid),
    {
      manual: true,
      onSuccess(result) {
        _getCourierList(warehouseUuid);
        hideModal();
      },
    },
  );

  const showModal = () => {
    setVisiable(true);
  };
  const hideModal = () => {
    setVisiable(false);
  };

  const onEditClick = (current) => {
    history.push(
      `/settings/logistics/courieraccount/setting/${transformTypeRes(
        current.type,
      )}/${
        current.type !== CourierAccountType.SF_GLOBAL
          ? get(current, 'qsfAccount.location', 'None')
          : SFLocation.GLOBAL
      }/${warehouseUuid}/${current.uuid}`,
    );
  };

  const onDelClick = (current) => {
    setModalTitle(
      <span>
        <InfoCircleFilled
          className={styles.headerIcon}
          style={{ color: '#ff695f' }}
        />
        <span>
          {getI18n('storeLogistics.courierAccount.deleteCourierAccount')}
        </span>
      </span>,
    );
    setModalContent(
      <DelModalContent
        onModalCancel={hideModal}
        onModalConfirm={() => _delCourier(current.uuid)}>
        <div className={styles.modalContent}>
          {getI18n('storeLogistics.courierAccount.deleteCourierAccountContent')}
        </div>
      </DelModalContent>,
    );
    showModal();
  };

  const onAddClick = () => {
    setModalTitle(getI18n('storeLogistics.courierAccount.addcourieraccount'));
    setModalContent(<AddCourierAccount setVisiable={setVisiable} />);
    setVisiable(true);
  };
  // table 列数据
  const columns = [
    {
      title: getI18n('storeLogistics.courierAccount.courierAccountName'),
      dataIndex: 'name',
      key: 'name',
      default: true,
      minWidth: 320,
      // childGenerate: (_, record) => {
      //   return <div>{getCourierShow(record)}</div>;
      // },
    },
    {
      title: getI18n('storeLogistics.courierAccount.courierVendor'),
      key: 'courier',
      default: true,
      minWidth: 320,
      childGenerate: (_, record) => {
        return <div>{getCourierShow(record)}</div>;
      },
    },
    {
      title: getI18n(
        'storeLogistics.courierAccount.waybillNumberAutoGeneration',
      ),
      key: 'waybillNumberAutoGenerate',
      dataIndex: 'waybillNumberAutoGenerate',
      default: true,
      minWidth: 320,
      align: 'center',
      childGenerate: (text) => {
        return (
          <div className={styles.waybillNumberAutoGenerate}>
            {text ? getI18n('general.yes') : getI18n('general.no')}
          </div>
        );
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      align: 'center',
      width: 126,
      childGenerate: (_, record, index) => {
        return add_edit_courier_account_parcel_locker_delivery_method ? (
          <div className={styles.action}>
            <span
              className={record.defaultLocation ? styles.unable : styles.danger}
              onClick={() => onDelClick(record)}>
              {getI18n('general.delete')}
            </span>
            <span
              className={styles.primary}
              onClick={() => onEditClick(record)}>
              {getI18n('general.edit')}
            </span>
          </div>
        ) : (
          <div />
        );
      },
    },
  ];

  useEffect(() => {
    _getCourierList(warehouseUuid);
  }, []);
  return (
    <div
      className={`${styles.logisticsItemContainer} ${styles.courierAccountContainer}`}>
      <Spin spinning={getCourierListLoading || delCourierLoading}>
        {list.length === 0 ? (
          <div className={styles.norConfig}>
            <div className={styles.title}>
              {getI18n('storeLogistics.courierAccount.noDataTitle')}
            </div>
            <div className={styles.description}>
              {getI18n('storeLogistics.courierAccount.noDataDescription')}
            </div>
          </div>
        ) : (
          <div className={styles.table}>
            <SizeFittingTable
              id='CourierAccountTable'
              rowKey='uuid'
              pagination={false}
              dataSource={list}
              columns={columns}
              rowClassName={styles.row}
            />
          </div>
        )}
        <div>
          <Button
            type='primary'
            className={styles.button}
            onClick={onAddClick}
            disabled={!add_edit_courier_account_parcel_locker_delivery_method}>
            {getI18n('storeLogistics.courierAccount.addCourierAccount')}
          </Button>
        </div>
      </Spin>
      <Modal
        className={styles.courierAccountModal}
        width={600}
        visible={visiable}
        onCancel={hideModal}
        title={modalTitle}>
        {modalContent}
      </Modal>
    </div>
  );
};

export default CourierAccount;
